import React from 'react'
import { withStyles } from '@material-ui/core';
import Button from 'components/Button';

const style = theme => ({
	button: {
		marginLeft: theme.spacing(1),
	},
})

function InfoBarTitleButton({
	classes,
	onClick,
	disabled = false,
	Icon,
	IconAfter,
	label,
}) {
	return <Button
		variant='outlined'
		size='small'
		color='primary'
		className={classes.button}
		onClick={onClick}
		disabled={disabled}
	>
		{Icon && <Icon />}
		{label}
		{IconAfter && <IconAfter />}
	</Button>
}


export default withStyles(style)(InfoBarTitleButton);